import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const ButtonFadeContainer = styled.div`
  --oc-scroll-btn-size: 33;

  position: absolute;
  top: calc(50% - ((var(--oc-scroll-btn-size) / 2) * 1px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--oc-scroll-btn-size) * 1px + 60px);
  height: calc((var(--oc-scroll-btn-size) * 1px) + 1px);
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
  pointer-events: none;
  &:after {
    content: '';
    left: -2px;
    width: 10px;
    height: 10px;
  }
`;

export const ScrollButton = styled.button`
  --oc-scroll-btn-size: 33;

  position: absolute;
  top: calc(50% - ((var(--oc-scroll-btn-size) / 2) * 1px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--oc-scroll-btn-size) * 1px);
  height: calc(var(--oc-scroll-btn-size) * 1px);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  transform: translateX(0) translateY(-1px);
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  pointer-events: auto;
  &:after {
    content: '';
    left: -2px;
    width: 10px;
    height: 10px;
  }
`;

export const LeftButtonFadeContainer = styled(ButtonFadeContainer)`
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.05)
  );
`;

export const RightButtonFadeContainer = styled(ButtonFadeContainer)`
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.05),
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
`;

export const LeftButton = styled(ScrollButton)`
  left: 0px;

  &:after {
    border-top: 2px solid var(--oc-text-body);
    border-left: 2px solid var(--oc-text-body);
    transform: rotate(-45deg);
  }
`;

export const RightButton = styled(ScrollButton)`
  right: 0px;

  &:after {
    border-top: 2px solid var(--oc-text-body);
    border-right: 2px solid var(--oc-text-body);
    transform: rotate(45deg) translate(-2px, 1px);
  }
`;

export const buttonSlideOut = css`
  ${LeftButtonFadeContainer}& {
    transform: translateX(-250px);
  }
  ${RightButtonFadeContainer}& {
    transform: translateX(250px);
  }
`;

export const buttonHide = css`
  display: none;
`;
